import React from 'react';
import { Dimensions, Image, Platform, StyleSheet, Text, TouchableHighlight, TouchableOpacity, View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { useToast } from 'react-native-toast-notifications';
import * as RootNavigation from '../navigation/RootNavigation';
import colors from '../resources/colors';
import images from '../resources/images';
import { isTablet } from 'react-native-device-info';
import FirebaseService from '../controllers/FirebaseService';

const Button = ({ icon, text, handlePress, tintColor, disclosureTint }) => (
  <TouchableHighlight
    underlayColor={colors.buttonHighlight}
    onPress={handlePress}>
    <View style={styles.button}>
      <Image style={[styles.icon, { tintColor: tintColor ? tintColor : undefined }]} source={icon} />
      <Text style={styles.text} allowFontScaling={false}>
        {text}
      </Text>
      <Image style={[styles.disclosure, { tintColor: disclosureTint ? disclosureTint : undefined }]} source={images.Button_Disclosure_Right_Grey} />
    </View>
  </TouchableHighlight>
);

const ButtonRow = ({ icon, text, handlePress, tintColor, disclosureTint }) => (
  <TouchableHighlight
    underlayColor={colors.buttonHighlight}
    style={styles.ButtonRow}
    onPress={handlePress}>
    <View style={styles.ButtonRow}>
      <Image style={[styles.icon, { tintColor: tintColor ? tintColor : undefined }]} source={icon} />
      <Text style={styles.text} allowFontScaling={false}>
        {text}
      </Text>
      <Image style={[styles.disclosure, { marginEnd: 0, tintColor: disclosureTint ? disclosureTint : undefined }]} source={images.Button_Disclosure_Right_Grey} />
    </View>
  </TouchableHighlight>
);

const VerticalSeparator = () => <View style={styles.verticalSeparator} />;

const Separator = () => <View style={styles.separator} />;

const ExploreComponent = () => {
  const toast = useToast();

  const handlePress = async (type) => {
    // !__DEV__ &&

    switch (type) {
      case 'Browse':
        await FirebaseService.logEvent('dashboard_explore', { option: 'Browse' });
        RootNavigation.navigate('Browse');
        break;
      case 'Bookmarks':
        await FirebaseService.logEvent('dashboard_explore', { option: 'Bookmarks' });
        RootNavigation.navigate('Bookmarks');
        break;
      case 'ThisWeeks':
        await FirebaseService.logEvent('dashboard_explore', { option: "This week's Services" });
        RootNavigation.navigate('ThisWeeks');
        break;
      default:
        toast.show('Not implemented', { id: 'text' });
        break;
    }
  };

  const horizontal = Dimensions.get('window').width > 700;

  if (horizontal) {
    return (
      <View style={styles.containerRow}>
        <ButtonRow
          tintColor={colors.grey60}
          disclosureTint={colors.grey50}
          icon={images.Button_Calendar_Grey}
          text="Browse all dates"
          handlePress={() => handlePress('Browse')}
        />
        <VerticalSeparator />
        <ButtonRow
          tintColor={colors.grey60}
          disclosureTint={colors.grey50}
          icon={images.Button_Bookmarks_Grey}
          text="Bookmarks"
          handlePress={() => handlePress('Bookmarks')}
        />
        <VerticalSeparator />
        <ButtonRow
          tintColor={colors.grey60}
          disclosureTint={colors.grey50}
          icon={images.Button_This_Week}
          text="This week’s Services"
          handlePress={() => handlePress('ThisWeeks')}
        />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <Button
        tintColor={colors.grey60}
        disclosureTint={colors.grey50}
        icon={images.Button_Calendar_Grey}
        text="Browse all dates"
        handlePress={() => handlePress('Browse')}
      />
      <Separator />
      <Button
        tintColor={colors.grey60}
        disclosureTint={colors.grey50}
        icon={images.Button_Bookmarks_Grey}
        text="Bookmarks"
        handlePress={() => handlePress('Bookmarks')}
      />
      <Separator />
      <Button
        tintColor={colors.grey60}
        disclosureTint={colors.grey50}
        icon={images.Button_This_Week}
        text="This week’s Services"
        handlePress={() => handlePress('ThisWeeks')}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderRadius: 4,
    backgroundColor: colors.accentWhite,
    borderWidth: 1,
    borderColor: colors.grey40,
    marginTop: 5,
    marginBottom: 25,
    paddingBottom: 5,
  },
  containerRow: {
    marginTop: 5,
    marginBottom: 25,
    flexDirection: 'row',
  },
  button: {
    height: 60,
    flexDirection: 'row',
    alignItems: 'center',
  },
  ButtonRow: {
    height: 60,
    borderRadius: 4,
    backgroundColor: colors.accentWhite,
    borderWidth: 1,
    borderColor: colors.grey40,
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  icon: {
    height: 44,
    width: 44,
    marginEnd: 5,
  },
  text: {
    flex: 1,
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 17,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 24,
    letterSpacing: 0.1,
    color: colors.grey90,
  },
  disclosure: {
    height: 44,
    width: 44,
    marginEnd: 15,
  },
  separator: {
    height: 1,
    backgroundColor: colors.grey30,
    marginStart: 44,
    marginEnd: 15,
  },
  verticalSeparator: {
    width: 20,
  }
});

export default ExploreComponent;
